export default "<app-navbar-scannerg [showAccount]=\"showAccount\"></app-navbar-scannerg>\r\n<router-outlet></router-outlet>";